import { render, staticRenderFns } from "./Interactable.vue?vue&type=template&id=d215517a&scoped=true&"
import script from "./Interactable.vue?vue&type=script&lang=js&"
export * from "./Interactable.vue?vue&type=script&lang=js&"
import style0 from "./Interactable.vue?vue&type=style&index=0&id=d215517a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d215517a",
  null
  
)

export default component.exports